import {
	Directive,
	ElementRef,
	HostListener,
	inject,
	input,
	Input,
} from "@angular/core"
import { LangService } from "@app/services/lang.service"

@Directive({
	selector: "[titleLang]",
})
export class TitleLangDirective {
	el = inject(ElementRef)
	lang = inject(LangService)

	titleLang = input<string>("")

	ngAfterViewInit() {
		this.el.nativeElement.title = this.lang.getVal(this.titleLang())
	}
}
